var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 9 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.546 7.498c0-.38-.131-.696-.454-1.003L2.584 1.104A1.14 1.14 0 0 0 1.742.76c-.681 0-1.23.55-1.23 1.216 0 .344.139.651.395.9l4.776 4.63L.907 12.12c-.256.256-.395.564-.395.9 0 .667.549 1.216 1.23 1.216q.493-.002.842-.344l5.508-5.39c.315-.308.454-.616.454-1.004"
  })));
};
export default SvgChevronRight;